var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMenuUsers = function SvgMenuUsers(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.461 14.023C12.424 14.632 11.258 15 10 15C8.742 15 7.576 14.632 6.539 14.023C2.894 14.262 0 17.296 0 21V22.73L0.695 22.953C0.829 22.995 4.038 24 10 24C15.962 24 19.171 22.995 19.305 22.953L20 22.73V21C20 17.296 17.106 14.262 13.461 14.023Z",
    fill: "#8D93AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13C13.379 13 16 9.237 16 6C16 2.691 13.309 0 10 0C6.691 0 4 2.691 4 6C4 9.237 6.621 13 10 13Z",
    fill: "#8D93AB"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMenuUsers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/menu_users.7dccaf51cc91d85fe7416cbdaf882b7c.svg";